import * as $ from 'jquery';
import Popper from 'popper.js';

function initForms() {
  (<any> window).Popper = Popper;

  (<any> $.fn).selectpicker.Constructor.BootstrapVersion = '4';
  (<any> $.fn).selectpicker.Constructor.DEFAULTS.dropupAuto = false;
  (<any> $.fn).selectpicker.Constructor.DEFAULTS.noneResultsText = 'Niks gevonden voor {0}';

  Popper.Defaults.modifiers.flip.enabled = false;
  Popper.Defaults.modifiers.preventOverflow.enabled = false;
  Popper.Defaults.modifiers.shift.enabled = false;
  Popper.Defaults.modifiers.hide.enabled = false;

  // todo: set mobile to true for mobile-only
  (<any> $('.form select')).selectpicker({
    mobile: false,
    dropupAuto: false,    
    display: 'static'
  });

  // workaround method to compare input with other input
  const compareField = (currentControl, formGroupElement) => {
    if ($(currentControl).hasClass("js-form-control__compare-with-other")) {
      const classList = $(currentControl).attr('class').split(/\s+/);
      classList.map(function (className) {
        const prefix = "compare-with__";
        if (className.indexOf(prefix) == 0) {
          const fieldName = className.substring(prefix.length);

          if ($("#FormModel_MyForm_" + fieldName).val() !== $(currentControl).val()) {
            $(currentControl).addClass("is-invalid");
            $(currentControl).removeClass("is-valid");
            if (formGroupElement.length > 0) {
              $(formGroupElement).addClass("form-group--is-invalid");
            }
          } else {
            $(currentControl).removeClass("is-invalid");
          }
        }
      });
    }
  };

  const conditionalRequiredField = (currentControl) => {

    if ($(currentControl).hasClass("js-form-control__required-trigger")) {
      const classList = $(currentControl).attr('class').split(/\s+/);
      classList.map(function (className) {
        const prefix = "js-form-control__required-trigger__";
        if (className.indexOf(prefix) == 0) {
          const condition = className.substring(prefix.length);
          if (condition !== "") {
            const fieldList = condition.split("|");
            
            fieldList.map((fieldName) => {
              conditionalRequiredField($("input[name='FormModel.MyForm." + fieldName + "']"));
              $("input[name='FormModel.MyForm." + fieldName + "']").each((index, item) => {
                if ($(item).length > 0) {
                  $(item).removeClass("is-invalid");
                  const formGroupElement =  $(item).closest(".form-group");
                  if (formGroupElement.length > 0) {
                    $(formGroupElement).removeClass("form-group--is-invalid");                                       
                  }
                  
                  ($(item)[0] as any).checkValidity();

                  if (formGroupElement.length > 0) {
                    compareField(item, formGroupElement);
                  }
                }
              });
            });            
          }
          
        }
      });
    }

    if ($(currentControl).hasClass("js-form-control__required-conditional")) {
      const classList = $(currentControl).attr('class').split(/\s+/);
      classList.map(function (className) {
        const prefix = "js-form-control__required-condition__";
        if (className.indexOf(prefix) == 0) {
          const condition = className.substring(prefix.length);
          if (condition !== "") {
            const [ fieldName, value ] = condition.split("=");
            const isRequired = $("input[name='FormModel.MyForm." + fieldName + "']:checked").val() === value;
            $(currentControl).prop("required", isRequired);
            
            const label = $(currentControl).parent().find("label");
            if (label.length > 0) {
              let labelText = label.text();
              if (labelText.indexOf("*") >= 0) {
                if (!isRequired) {
                  labelText = $.trim(labelText.replace("*", ""));
                  label.text(labelText); 
                }
              } else {
                if (isRequired) {
                  labelText = labelText + " *";
                  label.text(labelText); 
                }
              }
            }

          }
          
        }
      });
    }
  };

  var forms = document.getElementsByClassName('needs-validation');
  var validation = Array.prototype.filter.call(forms, function(form: any) {
    form.addEventListener('submit', function(event : Event) {
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();

        $('.needs-validation input').each((index, element) => {

          const formGroupElement =  $(element).closest(".form-group");

          if (($(element)[0] as any).validity && !($(element)[0] as any).validity.valid) {
            if (formGroupElement.length > 0) {
              $(formGroupElement).addClass("form-group--is-invalid");
            }
          } else {
            if (formGroupElement.length > 0) {
              $(formGroupElement).removeClass("form-group--is-invalid");
            }
          }
        });
      }
      form.classList.add('was-validated');

      $('.needs-validation input').each((index, element) => {

        const formGroupElement =  $(element).closest(".form-group");
        compareField(element, formGroupElement);
        conditionalRequiredField(element);

        if ($("input.is-invalid").length > 0) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }, false);
  });

  const validateFormControl = (event) => {

    const formGroupElement =  $(event.target).closest(".form-group");

    if ((<any> event.target).checkValidity()) {
      $(event.target).removeClass("is-invalid");
      $(event.target).addClass("is-valid");

      if (formGroupElement.length > 0) {
        $(formGroupElement).removeClass("form-group--is-invalid");
      }
    } else {
      $(event.target).addClass("is-invalid");
      $(event.target).removeClass("is-valid");

      if (formGroupElement.length > 0) {
        $(formGroupElement).addClass("form-group--is-invalid");
      }
    }
    compareField(event.target, formGroupElement);
    conditionalRequiredField(event.target);
  };

  $('.form input').on('blur', validateFormControl);
  $('.form input').on('input', validateFormControl);
  $('.form input').on('change', validateFormControl);

  if ($(".content-vind-je-bedrijf__selector select").length > 0) {
    $(".content-vind-je-bedrijf__selector select").change(function (event) {
      location.href = (<any> this).value;
    });
  }

}

export { initForms };